var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wsp__products"},[_c('div',{staticClass:"wsp__list"},_vm._l((_vm.productList),function(item,index){return _c('ProductCard',{key:item.spu,attrs:{"option":item}})}),1),_c('Subtotal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }